





function PageHome() {
  return (
    <div className="nc-PageHome relative overflow-hidden">
    
        Welcome to the Beyond Booking Engine App
      
    </div>
  );
}

export default PageHome;
